export default class Tab {
    public type: string = "";
    public src: HTMLImageElement;
    constructor(type: string, src: HTMLImageElement) {
        this.type = type;
        this.src = src;
    }
}
